import { actionType } from "../../helpers/reducers";

export const STATUS_USER_LOADED = "status/USER_LOADED";

export const statusUserLoaded = actionType(STATUS_USER_LOADED);
